var appSelector = document.getElementById("UpSell");
if (appSelector) {
  var appTemplate = document.getElementById("UpSellTemplate");
  if (appTemplate) {
  var app = new Vue(
      {
        el: appSelector,
        template: appTemplate.innerHTML,
        data: {
          items: [],
          selectedVariant: null,
          currency: "$",
          isAddingToCart: false,
          showQuickview: false,
          currentQuickviewProduct: null,
          currentProductId: appTemplate.dataset.productId
        },
        mounted() {
          var self = this;
          $.ajax({
            url: 'https://gearhuman.co/upsell/get?product_id=' + this.currentProductId,
            success: function(res) {
              if (res && res.success) {
                if (res.upsell) {
                  for (var i =0; i < res.upsell.length; i++) {
                  	var upsell = res.upsell[i];
                    var data = JSON.parse(upsell.raw_data);
                    data['type'] = 'product';
                    data['url'] = '/products/' + data['handle'];
                    data['variants'] = self._updateVariantsData(data['variants'], data);
                    data['selectedVariant'] = self._getDefaultVariant(data['variants']);
                    data['selectedVariantId'] = data['selectedVariant'].id;
                    data['selected'] = true;
                    data['option1'] = data['selectedVariant']['option1'];
                    data['option2'] = data['selectedVariant']['option2'];
                    data['option3'] = data['selectedVariant']['option3'];
                    self.items.push(data);
                   }
                }
              }
            }
          });
          var selectedVariantElem = document.getElementById("UpSellCurrentVariant");
          if (selectedVariantElem) {
          	this.selectedVariant = JSON.parse(selectedVariantElem.innerHTML);
            this.selectedVariant.selected = true;
          }
        },
        computed: {
          selectedItems() {
          	var result = [];
            if (this.selectedVariant) {
            	result.push(this.selectedVariant);
            }
            for (var j = 0; j < this.items.length; j++) {
              if (this.items[j].selected) {
                if (this.items[j].type == 'variant') {
                	result.push(this.items[j]);
                } else if(this.items[j].selectedVariantId) {
                  for (var v = 0; v < this.items[j].variants.length; v++) {
                    if (this.items[j].variants[v].id == this.items[j].selectedVariantId) {
                      	this.items[j].variants[v]['url'] = this.items[j]['url'];
                      	this.items[j].variants[v]['parent_id'] = this.items[j]['id'];
                      	this.items[j].selectedVariant = this.items[j].variants[v];
                    	result.push(this.items[j].variants[v]);
                    }
                  }
                }
              }
            }
            return result;
          },
          quickViewVariant() {
            for(var i = 0; i<this.currentQuickviewProduct.variants.length; i++) {
            	var variant = this.currentQuickviewProduct.variants[i];
              if (variant['option1'] ===  this.currentQuickviewProduct['option1'] &&
                 variant['option2'] ===  this.currentQuickviewProduct['option2'] &&
                 variant['option3'] ===  this.currentQuickviewProduct['option3']) {
                return variant;
              
              }
            }
            return null;
          }
        },
        watch: {
        	
        },
        methods: {
          showModal(event, productId) {
          	event.stopImmediatePropagation();
            this.currentQuickviewProduct = this.getProductById(productId);
            if (this.currentQuickviewProduct.options) {
              for (var i =1; i<= this.currentQuickviewProduct.options.length; i++) {
              	this.currentQuickviewProduct['option'+i] = this.currentQuickviewProduct.selectedVariant['option'+i];
              }
                   
            }
            this.showQuickview = true;
          },
          getProductById(productId) {
            for (var i=0; i < this.items.length; i++) {
              if (this.items[i].id == productId) {
              return this.items[i];
              }
            }
            return null;
          },
          formatPrice(item) {
            var price = item;
            if (item.price) {
              if (price.type) {
                if (item.type === 'variant') {
                  price = item.price;
                } else {
                  price = item.selectedVariant.price;
                }
              } else {
              	price = item.price;
              }
              
            }
            return this.currency + (price/100).toFixed(2);
          },
          getTotalPrice() {
          	var total = 0;
            for (var i = 0; i < this.selectedItems.length; i++) {
            	total += this.selectedItems[i].price;
            }
            if (this.selectedItems.length === 2) {
              total = total * 0.95; // 5% discount off
            }
            if (this.selectedItems.length === 3) {
              total = total * 0.9; // 10% discount off
            }
            return this.formatPrice(total);
          },
          swatchOption(index, value){
          	this.currentQuickviewProduct['option'+index] = value;
          },
          _updateVariantsData($variants, $product) {
            return $variants.map(function(variant) {
            	variant['price'] = variant['price'] * 100;
              	variant['compare_at_price'] = variant['compare_at_price'] * 100;
              if (variant.available === undefined) {
                if (variant.inventory_management === null) {
                	variant['available'] = true;
                } else {
                	variant['available'] = variant.inventory_quantity > 0;
                }
              }
            if ($product.images && $product.images.length && variant.image_id) {
              for (var i =0; i < $product.images.length; i++) {
              	var image = $product.images[i];
                if (image.id === variant.image_id) {
                	variant['image'] = image.src;
                }
              }
              if (!variant['image'] && $product.image) {
              		variant['image'] = $product.image.src;
              }
            }
              return variant;
            });
          },
          _getDefaultVariant(variants) {
          	  var item = null;
            for (var j = 0; j < variants.length; j++) {
              if (variants[j].available === true) {
              	item = variants[j];
                break;
              }
            }
            return item;
          },
          addToCart(event, quickViewItem = null) {
          	var self = this;
            var button = $(event.target);
            self.isAddingToCart = true;
            $.post('/cart/add.js',{
                  items: this._getCartData(quickViewItem)
              },
              function(res) {
                  self.isAddingToCart = false;
              	$.ajax({
                    url: '/cart.js',
                    dataType: "json",
                    cache: false,
                    success: function(cart) {
                        self._refreshCart(cart);
                        if ($('html').hasClass("remodal-is-locked")) {
                            $('.remodal-close').click();
                        }

                        if ($('#header').is(':visible')) {
                            $('#header .cart_container').addClass('active_link');
                        } else if ($('.sticky_nav--stick').length) {
                            $('.sticky_nav .cart_container').addClass('active_link');
                        } else {
                            $('.top_bar .cart_container').addClass('active_link');
                        }

                        //block scrolling on mobile
                        if ($(window).width() <= 798) {
                            var $cart_container = $(this).parent();
                            if ($cart_container.hasClass('active_link')) {
                                $('body').addClass('blocked-scroll');
                            } else {
                                $('body').addClass('blocked-scroll');
                            }
                        }
                      if (quickViewItem) {
                      	self.showQuickview = false;
                      }
                    }
                });
              }
            );
          },
          _getCartData(quickViewItem = null) {
          	var cartData = [];
            if (quickViewItem) {
            	cartData.push({
                  id: quickViewItem.id,
                  quantity: 1
                });
            } else {
              for (var i = 0; i < this.selectedItems.length; i++) {
                cartData.push({
                  id: this.selectedItems[i].id,
                  quantity: 1
                });
              }
            }
            
            return cartData;
          },
          _refreshCart(cart) {
            $(".cart_count").empty();
            $cartBtn = $(".cart_count");
            var value = $cartBtn.text() || '0';
            var cart_items_html = "";
            var cart_action_html = "";
            var cart_savings_html = "";
            var $cart = $(".cart_content form");
            var discounted_price_total = 0;
            var total_savings = 0;

            $cartBtn.text(value.replace(/[0-9]+/, cart.item_count));

            if (cart.item_count == 0) {
                $('.js-empty-cart__message').removeClass('hidden');
                $('.js-cart_content__form').addClass('hidden');
            } else {
                $('.js-empty-cart__message').addClass('hidden');
                $('.js-cart_content__form').removeClass('hidden');

                $.each(cart.items, function(index, item) {
                    var line_id = index + 1;
                    cart_items_html += '<li class="cart_item clearfix">' + '<a href="' + item.url + '">';
                    if (item.image) {
                        cart_items_html += '<div class="cart_image">' + '<img src="' + item.image.replace(/(\.[^.]*)$/, "_compact$1").replace('http:', '') + '" alt="' + htmlEncode(item.title) + '" />' + '</div>';
                    }

                    cart_items_html += '<div class="cart_item__title"><div class="item_title">' + item.title;

                    if (item.properties) {
                        $.each(item.properties, function(title, value) {
                            if (value) {
                                cart_items_html += '<div class="line-item">' + title + ': ' + value + '</div>';
                            }
                        });
                    }
                    cart_items_html += '</div></a>';

                    cart_items_html += '<div class="left product-quantity-box">' + '<span class="ss-icon product-minus js-change-quantity" data-func="minus"><span class="icon-minus"></span></span>' + '<input type="number" min="0" class="quantity" name="updates[]" id="updates_' + item.id + '" value="' + item.quantity + '" data-line-id="' + line_id + '" />' + '<span class="ss-icon product-plus js-change-quantity" data-func="plus"><span class="icon-plus"></span></span>' + '</div>' + '</div>';

                    cart_items_html += '<strong class="right price">';

                    $.ajax({
                        dataType: "json",
                        async: false,
                        cache: false,
                        url: "/products/" + item.handle + ".js",
                        success: function(data) {
                            var variant_id = item.variant_id;
                            var variant = $.grep(data.variants, function(v) {
                                return v.id == variant_id;
                            });

                            if (variant[0] && variant[0].compare_at_price > item.price) {
                                cart_items_html += ' <span class="money was_price">' + Shopify.formatMoney(variant[0].compare_at_price, $('body').data('money-format')) + '</span> ';
                                discounted_price_total += item.price * item.quantity;
                                total_savings += variant[0].compare_at_price * item.quantity;
                            }
                        }
                    });

                    cart_items_html += '<span class="money">' + Shopify.formatMoney(item.price, $('body').data('money-format')) + '</span></strong>' + '</div>';

                });

                cart_action_html += '<span class="right"><span class="money">' + Shopify.formatMoney(cart.total_price, $('body').data('money-format')) + '</span></span>' + '<span>Subtotal</span>';

                if (total_savings > 0) {
                    cart_savings_html = '<span class="right"><span class="money">' + Shopify.formatMoney(total_savings - discounted_price_total, $('body').data('money-format')) + '</span></span>' + '<span>Total Savings</span>';
                } else {
                    cart_savings_html = "";
                }
              $('.js-cart_items').html(cart_items_html);
              $('.js-cart_subtotal').html(cart_action_html);
              $('.js-cart_savings').html(cart_savings_html);
            }
        },
          _getOptionsData(id) {
          		var optionElem = document.getElementById('ProductUpsellOptionData-'+id);
            if (optionElem) {
            	return JSON.parse(optionElem.innerHTML);
            }
            return null;
          },
          switchVariant() {
            for (var i = 0; i < 2; i++) {
              var p = this.items[i];
              if (p.type == 'product' && p.id == this.currentQuickviewProduct.id) {
                p.selectedVariantId = this.quickViewVariant.id.toString();
                this.showQuickview = false;
              }
            }
          },
          getImageSrc(item) {
            $src = item && item.featured_image && item.featured_image.src ? item.featured_image.src : '';
            if ($src == '') {
              $src = item && item.image ? item.image : '';
            }
            return $src;
          },
          addQuickviewItem(event) {
          	this.addToCart(event, this.quickViewVariant);
          }
      }
  	});
  }
}